module.exports = __webpack_public_path__ + "static/elected-officials-2-24c8ec1f6ac81bfdb5145a49230ebfa5.jpg";